<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs2-21",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 41,
      nextPage: '/questionnaire/section3',
      navigateType: 'CLICK_NEXT',
      content: {
        componentsType: {
          pc: 'normalBtn',
          mobile: 'longBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/21-Women’s Health.png'),
        mainTitle: 'Do you have any of the following vaginal symptoms?',
        subTitle: 'Select all that apply.',
        btn: [
          [
            {
              text: 'Itching',
            },{
              text: 'Buming sensation',
            },{
              text: 'Irritating',
            }
          ],[
            {
              text: 'Erythema',
            },{
              text: 'None of these',
              unique: true
            }
          ]
        ],
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
